import * as React from "react";

import { cn } from "src/lib/utils";

const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
	<div
		ref={ref}
		className={cn("tw-rounded-lg tw-border tw-border-border tw-bg-card tw-text-card-foreground tw-shadow-card", className)}
		{...props}
	/>
));
Card.displayName = "Card";

const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
	<div
		ref={ref}
		className={cn("tw-flex tw-items-center tw-justify-between tw-gap-3 tw-border-b tw-border-border tw-px-4 tw-py-3 sm:tw-px-5", className)}
		{...props}
	/>
));
CardHeader.displayName = "CardHeader";

const CardTitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
	({ className, children, ...props }, ref) => (
		<h3 ref={ref} className={cn("tw-text-[15px] tw-font-semibold tw-leading-none tw-tracking-tight", className)} {...props}>
			{children}
		</h3>
	)
);
CardTitle.displayName = "CardTitle";

const CardDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
	({ className, ...props }, ref) => <p ref={ref} className={cn("tw-text-[13px] tw-text-text-soft", className)} {...props} />
);
CardDescription.displayName = "CardDescription";

const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
	<div ref={ref} className={cn("tw-p-4 sm:tw-p-5", className)} {...props} />
));
CardContent.displayName = "CardContent";

const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
	<div ref={ref} className={cn("tw-flex tw-items-center tw-border-t tw-border-border tw-px-4 tw-py-3 sm:tw-px-5", className)} {...props} />
));
CardFooter.displayName = "CardFooter";

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
